import api from "@/services/api"
import { FormattingRuleSetting } from "@/types/insights/formattingRuleSetting"

class ApiFormattingRuleSettings {
	private get axios () {
		return api.getAxios()
	}

	public async formattingRuleSettingsList (): Promise<FormattingRuleSetting[]> {
		return (await this.axios.get("/formattingRules")).data
	}

	public async formattingRuleSettingsSave (
		formattingRuleSettings: FormattingRuleSetting
	): Promise<string> {
		return (await this.axios.post("/formattingRules", formattingRuleSettings))
			.data
	}

	public async formattingRuleSettingsDelete (
		formattingRuleSettings: FormattingRuleSetting
	): Promise<void> {
		await this.axios.delete(`/formattingRules/${formattingRuleSettings.id}`)
	}
}

const apiFormattingRuleSettings = new ApiFormattingRuleSettings()

export default apiFormattingRuleSettings
